import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { CgSpinner } from 'react-icons/cg';

import Button from 'common-components/Button';
import useKeyboardShortcut from 'lib/keyboard-shortcut';

import './reviewMenu.style.css';


const ReviewMenu = ({
  onSave,
  onIgnore,
  onSaveAndNext,
  onIgnoreAndNext,
  onClose,
  data,
  priviledge,
  isLoading,
  saveSpinner,
  saveAndNextSpinner,
  ignoreSpinner,
  ignoreAndNextSpinner
}) => {
  const saveKey = ['Shift', 'S']
  const ignoreKey = ['Shift', 'I']
  const saveAndNextdKey = ['S', 'N']
  const ingoreAndNextKey = ['I', 'N']

  const handleSaveKeyboardShortcut = useCallback(keys => {
    onSave();
  }, [onSave]);

  const handleIgnoreKeyboardShortcut = useCallback(keys => {
    onIgnore();
  }, [onIgnore]);

  const handleSaveNextKeyboardShortcut = useCallback(keys => {
    onSaveAndNext(data);
  }, [onSaveAndNext]);

  const handleIgnoreNextKeyboardShortcut = useCallback(keys => {
    onIgnoreAndNext(data);
  }, [onIgnoreAndNext]);

  useKeyboardShortcut(saveKey, (!isLoading && (priviledge.is_admin || priviledge.is_reviewer)) ? handleSaveKeyboardShortcut : () => { });
  useKeyboardShortcut(ignoreKey, (!isLoading && (priviledge.is_admin || priviledge.is_reviewer)) ? handleIgnoreKeyboardShortcut : () => { });
  useKeyboardShortcut(saveAndNextdKey, (!isLoading && (priviledge.is_admin || priviledge.is_reviewer)) ? handleSaveNextKeyboardShortcut : () => { });
  useKeyboardShortcut(ingoreAndNextKey, (!isLoading && (priviledge.is_admin || priviledge.is_reviewer)) ? handleIgnoreNextKeyboardShortcut : () => { });

  const isDisabled = () => {
    return (!isLoading && (priviledge.is_admin || priviledge.is_reviewer)) ? false : true
  };

  return (
    <>
      <div className='review-menu'>
        <div className='save'>
          <Button
            onClick={() => onSave()}
            disabled={isDisabled()}
          >
            {saveSpinner && <CgSpinner className='review-botton-spinner spin' />}
            Save
        </Button>
        </div>
        <div className='ignore'>
          <Button
            onClick={() => onIgnore()}
            disabled={isDisabled()}
          >
            {ignoreSpinner && <CgSpinner className='review-botton-spinner spin' />}
            Ignore
        </Button>
        </div>
        <div className='save-and-next'>
          <Button
            onClick={() => onSaveAndNext(data)}
            disabled={isDisabled()}
          >
            {saveAndNextSpinner && <CgSpinner className='review-botton-spinner spin' />}
            Save and next
        </Button>
        </div>
        <div className='ignore-and-next'>
          <Button
            onClick={() => onIgnoreAndNext(data)}
            disabled={isDisabled()}
          >
            {ignoreAndNextSpinner && <CgSpinner className='review-botton-spinner spin' />}
            Ignore and next
        </Button>
        </div>
        <div className='cancel'>
          <Button
            onClick={() => onClose()}
            disabled={isDisabled()}
          >
            Close
        </Button>
        </div>
      </div>
    </>
  )
};

const mapStateToProps = ({
  authentication: { priviledge } }) => ({
    priviledge
  });

export default connect(mapStateToProps)(ReviewMenu);
